<template>
  <el-table-column :label="label" :prop="prop" class-name="customer-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '顧客コード'
    },
    prop: {
      type: String,
      default: 'customer_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.customer-code {
      width: 7.5em;
    }
  }
}
</style>
